import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@mui/material';
import GenericModal from '../../../../common/Modals/GenericModal/GenericModal';
import { useTranslation } from 'react-i18next';
export const ModalInitForm = ({ open, setOpen }) => {
    const { t } = useTranslation();
    return (_jsx(GenericModal, Object.assign({ open: open, title: t("PDDForm.modalInitForm.title"), cssProps: { width: "450px" }, primaryAction: _jsx(Button, Object.assign({ onClick: () => setOpen(false), variant: "contained", color: "primary" }, { children: t("common.btn.ok").toUpperCase() })) }, { children: _jsx("div", { className: "modal-init-form-content-text", dangerouslySetInnerHTML: {
                __html: t("PDDForm.modalInitForm.contentText")
            } }) })));
};
